export const MAX_GUESSES = 4;  // Changed from 6 to 4
export const TOTAL_ROUNDS = 5; // Total number of images
export const MAX_HINTS = 3;    // Hints per image 